// Import Core Components here
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// Import App depedency here
import { Input, Utils } from "arv-reactcomponents";
import { MYACCOUNTPAGE } from "npmlinks-constants";

const { IFSC_CODE } = MYACCOUNTPAGE;

class IFSCCodeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserInputValid: false,
      ifscCodeErrorMsg: "",
      ifscCodeErrorClass: "",
      isValid: "",
    };

    this.onBlur = this.onBlur.bind(this);
    this.validateIFSCCode = this.validateIFSCCode.bind(this);
  }

  onBlur() {
    let ifscCodeErrorClass = "nwc-hidden";
    let isValid = "";
    if (!this.state.isUserInputValid) {
      ifscCodeErrorClass = "";
      isValid = "is-invalid";
    }
    this.setState({ ifscCodeErrorClass, isValid });
    this.props.onBlur();
  }

  validateIFSCCode(e) {
    this.setState({ ifscCodeErrorClass: "nwc-hidden" });
    const validateUserField = this.validateIFSCCodeRef.getValidatedOutput(
      e.target.value,
    );
    this.setState({
      isUserInputValid: validateUserField.isValid,
      ifscCodeErrorMsg: validateUserField.errorMsg,
      isValid: "",
    });
    this.props.validateIFSCInput(validateUserField);
  }

  render() {
    const { ifscCodeErrorMsg, ifscCodeErrorClass, isValid } = this.state;
    const {
      className,
      placeholder,
      name,
      text,
      errorMsgClassName,
      onBlur,
      ...otherProps
    } = this.props;
    return (
      <Fragment>
        <Input
          className={`${className} ${isValid}`}
          name={name}
          onBlur={this.onBlur}
          onChange={this.validateIFSCCode}
          placeholder={placeholder}
          type="text"
          value={text}
          ref={values => {
            this.validateIFSCCodeRef = values;
          }}
          validateWithPattern={[
            {
              pattern: /^[A-Z|a-z]{4}[0][\d]{6}$/,
              msg: IFSC_CODE.invalidIFSC,
            },
          ]}
          {...otherProps}
        />
        <div
          className={`nw-form-err-msg ${ifscCodeErrorClass} ${errorMsgClassName}`}
        >
          {ifscCodeErrorMsg}
        </div>
      </Fragment>
    );
  }
}

IFSCCodeInput.defaultProps = {
  className: "",
  errorMsgClassName: "",
  onBlur: Utils.noop,
};

IFSCCodeInput.propTypes = {
  className: PropTypes.string,
  errorMsgClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  validateIFSCInput: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: IFSCCodeInput,
  component: IFSCCodeInput,
};

export default ProjectComponent;
